import { render, staticRenderFns } from "./discountServiceList.vue?vue&type=template&id=367f665c&scoped=true&"
import script from "./discountServiceList.vue?vue&type=script&lang=js&"
export * from "./discountServiceList.vue?vue&type=script&lang=js&"
import style0 from "./discountServiceList.vue?vue&type=style&index=0&id=367f665c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f665c",
  null
  
)

export default component.exports